import React, { useEffect, useState } from "react";
import CouponList, { CouponItem } from "../../components/coupon";
import { getUserCoupons } from "../../service";
import useUserInfo from "../../routers/useUserInfo";
import FixedTabs from "../../components/fixed-tabs";
import Pagination from "../../components/pagination";
import usePagination from "../../routers/usePagination";
import { useModal } from "../../components/modal";
import { useHistory } from "react-router-dom";
import DiscountInput from "./discount-input";



function Discount() {

    const [lists, setLists] = useState<Array<CouponItem>>([]);
    const [active, setActive] = useState<number>(0);
    const [reload, setReload] = useState<number>(0);
    const [pageNum, setPage] = useState<number>(1);
    const userData = useUserInfo(false)
    const { pageRef, noMore, reset } = usePagination();
    const modal = useModal()
    const { goBack, push } = useHistory()

    useEffect(() => {
        if (userData) {
            getUserCoupons({
                userId: userData.id,
                pageNum,
                status: active
            }).then(res => {
                if (res.code === 1) {
                    const lists = res.data.list
                    if ((lists as Array<CouponItem>).length > 0) {
                        setLists(list => list.concat(lists))
                    } else {
                        noMore()
                    }
                } else {
                    noMore()
                }
            })
        } else {
            modal.show({
                content: '该功能需要用户登录，是否继续?',
                confirmText: '用户登陆',
                cancelText: '取消浏览',
                success(res) {
                    if (res.confirm) {
                        push('/login')
                    } else {
                        goBack()
                    }
                }
            })
        }

    }, [pageNum, active, reload])

    const TabChange = (index: number) => {
        setActive(index)
        setLists([])
        setPage(1)
        reset()
    }


    return <div className="discount">

        <DiscountInput onSuccess={() => {
            setPage(1)
            setReload(h => h + 1)
        }} />

        <FixedTabs autoFixed tabs={['待使用的券', '已使用的券', '已失效的券']} onChange={TabChange} />

        <CouponList dataLists={lists} onCouponClick={(id) => console.log(id)} />

        <Pagination ref={pageRef} length={lists.length} onChange={(n) => setPage(n)} />

    </div>
}

export default Discount;
